// Контроллер Stimulus для Select2 с пользователями
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { 
    placeholder: String,
    multiple: Boolean,
    search: Boolean,
    minimumInputLength: Number
  }

  connect() {
    console.log('Select2 контроллер подключен')
    // Проверяем готовность DOM и зависимостей
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initialize())
    } else {
      this.initialize()
    }
  }

  initialize() {
    // Добавляем небольшую задержку для гарантии загрузки всех зависимостей
    setTimeout(() => {
      this.initializeSelect2()
    }, 250)
  }

  disconnect() {
    if (this.hasSelectTarget && window.jQuery && window.jQuery(this.selectTarget).data('select2')) {
      window.jQuery(this.selectTarget).select2('destroy')
      console.log('Select2 уничтожен')
    }
  }

  initializeSelect2() {
    if (!this.hasSelectTarget) {
      console.warn('Select2: target element not found')
      return
    }

    // Проверяем наличие jQuery
    if (typeof window.jQuery === 'undefined') {
      console.error('Select2: jQuery не загружен')
      return
    }

    // Проверяем наличие Select2
    if (typeof window.jQuery.fn.select2 === 'undefined') {
      console.error('Select2: Select2 плагин не загружен')
      console.log('Доступные jQuery плагины:', Object.keys(window.jQuery.fn))
      return
    }
    
    const $ = window.jQuery
    const $select = $(this.selectTarget)
    
    // Проверяем, что элемент существует в DOM
    if ($select.length === 0) {
      console.warn('Select2: элемент select не найден')
      return
    }

    // Проверяем, не инициализирован ли уже Select2
    if ($select.data('select2')) {
      console.log('Select2 уже инициализирован, пропускаем')
      return
    }
    
    // Конфигурация Select2
    const config = {
      placeholder: this.placeholderValue || 'Выберите пользователя...',
      allowClear: true,
      width: '100%'
    }

    // Настройка поиска
    if (this.searchValue) {
      config.minimumInputLength = this.minimumInputLengthValue || 0
    } else {
      config.minimumInputLength = 9999 // Отключаем поиск
    }

    // Множественный выбор
    if (this.multipleValue) {
      config.closeOnSelect = false
    }

    // Кастомная функция сортировки результатов поиска
    config.sorter = function(data) {
      return data.sort(function(a, b) {
        const aText = a.text.toLowerCase()
        const bText = b.text.toLowerCase()
        
        if (aText < bText) return -1
        if (aText > bText) return 1
        return 0
      })
    }

    // Инициализируем Select2
    try {
      $select.select2(config)
    //   console.log('Select2 успешно инициализирован для элемента:', this.selectTarget)
      
      // События при изменении выбора
      $select.on('select2:select select2:unselect', (e) => {
        this.onSelectionChange(e)
      })

      // Обработка очистки поля
      $select.on('select2:clear', (e) => {
        this.onSelectionChange(e)
      })
      
    } catch (error) {
      console.error('Ошибка при инициализации Select2:', error)
      return
    }
  }

  onSelectionChange(event) {
    // Генерируем кастомное событие с данными о выбранных пользователях
    const detail = {
      selectedUsers: this.getSelectedUsers(),
      event: event
    }
    
    this.dispatch('change', { detail })
  }

  getSelectedUsers() {
    if (!this.hasSelectTarget) return []
    
    const $ = window.jQuery
    const selectedValues = $(this.selectTarget).val()
    
    if (!selectedValues) return []
    
    const values = Array.isArray(selectedValues) ? selectedValues : [selectedValues]
    return values.map(id => {
      const option = this.selectTarget.querySelector(`option[value="${id}"]`)
      return {
        id: id,
        text: option ? option.text : '',
        element: option
      }
    })
  }

  // Публичные методы для внешнего использования
  setValue(value) {
    if (!this.hasSelectTarget) return
    
    const $ = window.jQuery
    $(this.selectTarget).val(value).trigger('change')
  }

  clearSelection() {
    if (!this.hasSelectTarget) return
    
    const $ = window.jQuery
    $(this.selectTarget).val(null).trigger('change')
  }

  addOption(id, text) {
    if (!this.hasSelectTarget) return
    
    const option = new Option(text, id, false, false)
    this.selectTarget.appendChild(option)
  }

  removeOption(id) {
    if (!this.hasSelectTarget) return
    
    const option = this.selectTarget.querySelector(`option[value="${id}"]`)
    if (option) {
      option.remove()
    }
  }
}
